import React from 'react';
import loadingGif from '#GameFrontend/unauthorized/assets/loading.gif';
import { useLoading } from '#GameFrontend/contexts/LoadingContext'; // Adjust the path to your loading gif

const Loading: React.FC = () => {
	const { isLoading } = useLoading();

	if (!isLoading) return null;

	return (
		<div className="fixed inset-0 flex items-center justify-center bg-[#0911317F] bg-opacity-15 z-50 text-white">
			<img src={loadingGif} alt="Loading..." />
			<span>Loading...</span>
		</div>
	);
};

export default Loading;
